<template>
  <div>
    <a class='dropdown-trigger btn' :data-target="uid" style="width: 100%; text-transform: initial; text-align: inherit;" v-show="!disabled">
      {{label}}
    </a>
    <a class='btn' style="width: 100%; text-transform: initial; text-align: inherit;" v-show="disabled">
      {{label}}
    </a>
    <ul :id='uid' class='dropdown-content'>
      <template v-for="(items, grpname) in pestsgroups">
        <li v-on:click="selectedGroup(items[0].group_id)">{{grpname}}</li>
        <li v-on:click="selectedPest(pest.id)" v-for="pest in items">{{pest.name}}</li>
      </template>
    </ul>
  </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
    data: function() {
        return {
          uid: _.uniqueId("dropdown")
        }
    },
    mounted: function() {
      M.Dropdown.init(this.$el.querySelectorAll('.dropdown-trigger'), {});
    },
    methods: {
      selectedGroup: function(gid){
        this.$emit('update:group_id', gid);
        this.$emit('update:pest_id', null);
        this.$emit('changed');
      },
      selectedPest: function(pid){
        this.$emit('update:group_id', null);
        this.$emit('update:pest_id', pid);
        this.$emit('changed');
      }
    },
    props: { group_id: Number, pest_id: Number, pestsgroups: Object, disabled: Boolean },
    computed: {
      label: function(){
        if(_.keys(this.pestsgroups).length > 0){
          if(this.pest_id == null || this.pest_id == undefined || this.pest_id == 0){
            if(this.group_id == null || this.group_id == undefined || this.group_id == 0){
              return this.$t('place.select_group_or_pest')
            }else{
              return _(this.pestsgroups).values().flatten().keyBy("group_id").value()[this.group_id].group_name;
            }
          }else{
            return _(this.pestsgroups).values().flatten().keyBy("id").value()[this.pest_id].name;
          }
        }
      }
    },

}
</script>
<style scoped>
div {
    margin-left: auto;
    left: auto;
    right: auto;
    line-height: 2;
}
.btn{
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    color: black;
}
</style>